import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import maintenance from './maintenance';
import { mainApp } from './mainApp';

document.addEventListener("DOMContentLoaded", async function () {
    const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
    const authToken = localStorage.getItem('token');

    if (maintenanceMode && !authToken) {
        maintenance();
    } else {
        mainApp(document.getElementById('root'));
    }
});

serviceWorker.unregister();